import React, { useState } from "react";
import { FaFacebookF, FaTwitter, FaYoutube, FaInstagram } from "react-icons/fa";
import img from "../../../assets/Dashboard/Navbar/logo.webp";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ApiResponse } from "../../../redux/Slices/MainPageSlices/ApiSlice";
import { toast } from "react-toastify";

const Footer = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = (contentKey) => {
    navigate(`/legal/${contentKey}`);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleComparisonClick = (contentKey) => {
    navigate(`/comparison/${contentKey}`);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      dispatch(ApiResponse({ email }));
      setEmail("");
    } else {
      toast.error("Please enter a valid email address.");
    }
  };

  return (
    <footer className="bg-[#F4F7FA] pt-12 xl:pt-16 pb-4 px-4 xl:px-36">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 lg:grid-cols-5 ml-3 pb-5 xl:pb-6">
          <div className="hidden lg:block 2xl:mr-2 mt-1">
            <img src={img} className="h-8 2xl:h-10 2xl:w-48 mb-3 -mt-2 -ml-4" alt="my" />
            <h3 className="text-gray-700 text-[15px]">
              2117 Lake Ave, Altadena,
              <br />
              CA 91001, USA
              <br />
              Tel: 0236 834 5092
            </h3>
            <div className="flex space-x-4 mt-8">
              <button className="text-gray-700 hover:text-gray-900 ">
                <FaFacebookF />
              </button>
              <button className="text-gray-700 hover:text-gray-900 ">
                <FaTwitter />
              </button>
              <button className="text-gray-700 hover:text-gray-900 ">
                <FaYoutube />
              </button>
              <button className="text-gray-700 hover:text-gray-900 ">
                <FaInstagram />
              </button>
            </div>
          </div>

          <div className="text-[15px]">
            <h3 className="text-md font-semibold mb-4">Products & Services</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate("/exactness");
                  }}
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                >
                  Exactness
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate("/api");
                  }}
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                >
                  Api
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate("/bulk");
                  }}
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                >
                  Bulk
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate("/extension");
                  }}
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                >
                  Extension
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate("/pricing");
                  }}
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                >
                  Price Plans
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate("/zapier");
                  }}
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                >
                  Zapier
                </button>
              </li>
            </ul>
          </div>

          <div className="text-[15px]">
            <h3 className="text-md font-semibold mb-4">Legal stuff</h3>
            <ul className="space-y-3">
              <li>
                <button
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                  onClick={() => handleClick("privacy")}
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                  onClick={() => handleClick("terms")}
                >
                  Terms & Services
                </button>
              </li>
              <li>
                <button
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                  onClick={() => handleClick("cookie")}
                >
                  Cookie Policy
                </button>
              </li>
              <li>
                <button
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                  onClick={() => handleClick("gdpr")}
                >
                  GDPR Compliance
                </button>
              </li>
              <li>
                <button
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                  onClick={() => handleClick("data")}
                >
                  Data Processing
                </button>
              </li>
            </ul>
          </div>

          <div className="text-[15px]">
            <h3 className="text-md font-semibold mb-4">Comparison</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => handleComparisonClick("Anymail_Finder")}
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                >
                  AnyMail Finder
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleComparisonClick("Email_Hunter")}
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                >
                  Email Hunter
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleComparisonClick("Get_Prospect")}
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                >
                  Get Prospect
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleComparisonClick("ProsPio")}
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                >
                  ProsPio
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleComparisonClick("FindyEmail")}
                  className="text-gray-700 hover:text-gray-900 hover:underline"
                >
                  FindyEmail
                </button>
              </li>
            </ul>
          </div>

          <div className="text-[15px] lg:-ml-10">
            <h3 className="text-md font-semibold mb-4">Get More Info</h3>
            <form onSubmit={handleSubmit} className="max-w-sm">
              <div className="mb-4">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-background hover:bg-hover font-semibold text-white px-1 py-2 rounded"
              >
                Subscribe Now
              </button>
            </form>
          </div>
        </div>

        <div className="flex justify-center items-center text-gray-600 text-sm mt-8 border-t border-gray-400 pt-5">
          <p>&copy; 2024 ExactMail.io. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
